<template>
  <div v-if="!loading">
    <RepeatableFormGroup
        :value="value.subscription_types"
        label="Subscription Types"
        help-text="Filter the competition on subscription types. If no subscription types are selected, all subscription types will count."
        empty-text="No subscription types added."
        :errors="subscriptionTypeErrors"
        @input="emit('subscription_types', $event)"
    >
      <template v-slot:default="{ data, index, change, errors }">
        <SelectWidget
            :value="data.id"
            @input="change(index, 'id', $event)"
            :options="subscriptionTypes.map(subscriptionType => ({value: subscriptionType.id, label: subscriptionType.attributes.name}))"
            :error="(errors.id || [])[0]"
        />
      </template>
    </RepeatableFormGroup>
  </div>
</template>

<script>
import http from '@/http'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'
import RepeatableFormGroup from '../../../Forms/RepeatableFormGroup'

export default {
  components: {RepeatableFormGroup, SelectWidget},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    }
  },

  data() {
    return {
      subscriptionTypes: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    subscriptionTypeErrors() {
      return Object.entries(this.errors)
          .filter(entry => entry[0].startsWith('subscription_types.'))
          .reduce((result, entry) => ({
            ...result,
            [entry[0].substring('subscription_types.'.length)]: entry[1]
          }), {})
    }
  },

  methods: {
    load() {
      http.get('/api/v2/subscription-types').then(response => {
        this.subscriptionTypes = response.data.data

        this.loading = false
      })
    },

    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    }
  }
}
</script>
